<template>
  <b-col cols="12">
    <GenericTable
      id="tab_libraires"
      ref="genericTableListeLibraires"
      :actions="actions"
      :colonnes="cols"
      :endpoint-url="endpointUrl"
      :filterable-col="filterableCol"
      @action-callback="dispatchAction"
      @row-click="openDetails"
    />
    <LibraireModal />
    <ModalExportCommandesFactures />
  </b-col>
</template>

<script>
import GenericTable from "@/components/generics/genericTable/GenericTable.vue";
import LibraireModal from "@/components/libraires/LibraireModal.vue";
import ModalExportCommandesFactures from "@/components/commandes/ModalExportCommandesFactures.vue";

import config from "@/config";

import Api from "@/modules/axios";
import { displayErrorSelectOne } from "@/modules/utils";

export default {
  name: "ListeLibraires",
  components: {
    GenericTable,
    LibraireModal,
    ModalExportCommandesFactures,
  },
  data() {
    return {
      cols: [
        { key: "compte" },
        { key: "nom" },
        { key: "commune_facturation" },
        { key: "pays_facturation" },
        { key: "actif", defaultOrder: true },
      ],
      filterableCol: ["compte", "nom", "pays_facturation__nom"],
      endpointUrl: "/libraire",
    };
  },
  computed: {
    actions() {
      const actions = [
        { title: "Ajouter", callback: "add" },
        { title: "Exporter", callback: "export" },
      ];

      if (
        this.$store.state[this.$route.name]
        && this.$store.state[this.$route.name].displayArchived
      ) {
        actions.push({ title: "Désarchiver", callback: "unarchive" });
      } else {
        actions.push({ title: "Supprimer", callback: "delete" });
      }

      return actions;
    },
  },
  mounted() {
    this.$store.commit(
      `${this.$route.name}/setFormatDataFunction`,
      this.getVerbose,
    );
  },
  methods: {
    /**
     * Affiche la modale du libraire avec ses détails.
     * @public
     * @param {Object} libraire Libraire sélectionné.
     */
    openDetails(libraire) {
      this.$modal.show("libraire", {
        libraire,
      });
    },
    /**
     * Exécute les actions du tableau des libraires.
     * @public
     * @param {String} actionCode Action sélectionnée.
     */
    dispatchAction(actionCode) {
      // On execute le dispatch générique qui gére le delete
      const resCode = this.$refs.genericTableListeLibraires.genericDispatch(
        actionCode,
        this.$route.name,
        this.endpointUrl,
        "un libraire",
      );

      if (resCode === -1) {
        const checkedRows = this.$store.getters[
          `${this.$route.name}/rowDisplayed`
        ].filter((row) => row._checkBoxChecked);

        switch (actionCode) {
          case "add":
            this.$modal.show("libraire", { new: true });
            break;

          case "export":
            if (checkedRows.length === 1) {
              this.exportSimple();
            } else {
              displayErrorSelectOne("un libraire");
            }
            break;

          default:
            break;
        }
      }
    },
    /**
     * Met en forme les données du tableau des libraires.
     * @public
     * @param {Object} data Données du tableau.
     * @return {Promise}
     */
    getVerbose(data) {
      const dataCopy = data.results;

      // ======== Gestion des pays ==========
      const paysFacturationIds = [
        ...new Set(dataCopy.map((item) => item.pays_facturation)),
      ];

      const promise = Api()
        .get(`pays/?id__in=${paysFacturationIds.join(",")}&page_size=100`)
        .then((res) => {
          const tabPaysFacturation = res.data.results;
          dataCopy.forEach((ligne) => {
            ligne.pays_facturation_verbose = (
              tabPaysFacturation.find(
                (paysFacturation) => ligne.pays_facturation === paysFacturation.id,
              ) || {}
            ).nom;
          });
          return res;
        });
      // ======== FIN Gestion des pays ==========

      return promise;
    },
    /**
     * Exporte les données d'un libraire.
     * @public
     */
    exportSimple() {
      const checkedRows = this.$store.getters[
        `${this.$route.name}/rowDisplayed`
      ].filter((row) => row._checkBoxChecked);

      window.open(
        `${config.api.baseUrl}/export/libraire/?libraire=${checkedRows[0].id}`,
        "_blank",
      );
    },
  },
};
</script>

<style lang="scss">
#tab_libraires {
  .compte { min-width: 150px; }
  .nom { min-width: 200px; }
  .commune_facturation { min-width: 250px; }
  .pays_facturation { min-width: 250px; }
  .actif { width: 130px; }
}
</style>
